module.exports = __webpack_public_path__ + "img/A58A2511_min.d59c51c8.jpg";